import { StarIcon } from '@chakra-ui/icons';
import {
  Box,

  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Button,
  Heading,
  SimpleGrid,
  StackDivider,
  useColorModeValue,

  List,
  ListItem,
  Grid,
} from '@chakra-ui/react';

import { BsStar, BsStarFill, BsStarHalf } from 'react-icons/bs';

import { useEffect, useState } from 'react';

import { MdLocalShipping } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { addProductCart, getSingleProduct } from '../Redux/Products/action';
import Product from './Product';

export default function ProductDetail() {




  const navigate = useNavigate();

  const { id } = useParams();

  console.log("id : ", id)

  const dispatch = useDispatch();

  const currentProduct = useSelector(store => store.ecommerceData.currentProduct);

  console.log("Current Product", currentProduct)

  const [image, setImage] = useState(currentProduct.image)


  useEffect(() => {



    if (id) {
      dispatch(getSingleProduct(id, navigate));
    }

  }, [dispatch, navigate, id])



  const addToCartHandler = () => {

    currentProduct && dispatch(addProductCart(currentProduct));


  }











  return (
    <Container maxW={'7xl'}>
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 18, md: 24 }}>
        <Flex flexDirection="column" >
          <Image
            rounded={'md'}
            alt={'product image'}
            src={
              image || currentProduct.image
            }
            fit={'contain'}
            align={'center'}
            w={'100%'}
            h={{ base: '100%', sm: '400px', lg: '500px' }}
          />

          <Box padding="10px"  >

            <Grid templateColumns='repeat(3, 1fr)' gap={6}   >
              <Image
                rounded={'md'}
                alt={'product image'}
                src={
                  currentProduct.img1
                }
                fit={'contain'}
                _hover={{ border: "1px solid #10847e ", padding: '10px' }}
                w={'70%'}

                onClick={() => setImage(currentProduct.img1)}
              // h={{ base: '100%', sm: '400px', lg: '500px' }}
              />


              <Image
                rounded={'md'}
                alt={'product image'}
                src={
                  currentProduct.img2
                }
                fit={'contain'}
                align={'center'}
                w={'70%'}
                h={"70%"}
                _hover={{ border: "1px solid #10847e ", padding: '10px' }}
                onClick={() => setImage(currentProduct.img2)}
              // h={{ base: '100%', sm: '400px', lg: '500px' }}
              />



              <Image
                rounded={'md'}
                alt={'product image'}
                src={
                  currentProduct.img3
                }
                fit={'contain'}
                align={'center'}
                w={'70%'}
                h={"70%"}
                _hover={{ border: "1px solid #10847e ", padding: '10px' }}
                onClick={() => setImage(currentProduct.img3)}
              // h={{ base: '100%', sm: '400px', lg: '500px' }}
              />

            </Grid>
          </Box>





        </Flex>
        <Stack spacing={{ base: 6, md: 10 }}>
          <Box as={'header'}>
            <Heading
              lineHeight={1.1}
              fontWeight={600}
              fontSize={{ base: '2xl', sm: '4xl', lg: '5xl' }}>
              {currentProduct.title}
            </Heading>
            <Heading
              lineHeight={1.1}
              fontWeight={300}
              fontSize={{ base: '2xl', sm: '4xl', lg: '3xl' }}>
              {currentProduct.Subtitle}
            </Heading>
            <Text
              color={useColorModeValue('gray.900', 'gray.400')}
              fontWeight={300}
              fontSize={'2xl'}>
              ₹{currentProduct.price}
            </Text>
          </Box>
          <Flex>
            
            {
              Rating({ rating: Number(currentProduct.rating?.rate) })

            }




          </Flex>

          <Stack
            spacing={{ base: 4, sm: 6 }}
            direction={'column'}
            divider={
              <StackDivider
                borderColor={useColorModeValue('gray.200', 'gray.600')}
              />
            }>
            <VStack spacing={{ base: 4, sm: 6 }}>
              <Text
                color={useColorModeValue('gray.500', 'gray.400')}
                fontSize={'2xl'}
                fontWeight={'300'}>
                {currentProduct.description}
              </Text>
              <Text fontSize={'lg'}>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad
                aliquid amet at delectus doloribus dolorum expedita hic, ipsum
                maxime modi nam officiis porro, quae, quisquam quos
                reprehenderit velit? Natus, totam.
              </Text>
            </VStack>

          </Stack>

          <Link to={"/shoppingcart"}   >

            <Button
              rounded={'none'}
              w={'full'}
              mt={8}
              size={'lg'}
              py={'7'}
              bg={useColorModeValue('#10847e')}
              color={useColorModeValue('white', 'gray.900')}
              textTransform={'uppercase'}
              _hover={{
                transform: 'translateY(2px)',
                boxShadow: 'lg',
              }}

              onClick={addToCartHandler}

            >
              Add to cart
            </Button>
          </Link>
          <Stack direction="row" alignItems="center" justifyContent={'center'}>
            <MdLocalShipping color='#10847e' />
            <Text>2-3 business days delivery</Text>
          </Stack>
        </Stack>
      </SimpleGrid>
    </Container>
  );
}






function Rating({ rating }) {
  return (
    <Box display={"flex"} gap={"10px"} >
      {Array(5)
        .fill('')
        .map((_, i) => {

          // console.log( `rating`, rating);

          const roundedRating = Math.round(rating * 2) / 2;
          if (roundedRating - i >= 1) {
            return (
              <BsStarFill
                key={i}
                style={{ marginLeft: '1' }}
                color={'teal.500'}
              />
            );
          }
          if (roundedRating - i === 0.5) {
            return <BsStarHalf key={i} style={{ marginLeft: '1' }} />;
          }
          return <BsStar key={i} style={{ marginLeft: '1' }} />;
        })}

    </Box>
  );
}